export default __webpack_public_path__ + "static/2156-05e3b249a0be9087f244435a0665e029.gif";